export const dropdownTypes = {
    EDIT: "edit",
    DELETE: "delete"
}

export const currentTabValues = {
    APPS: 'APPS',
    WEBHOOK: 'WEBHOOK'
}